<template>
  <div class="home-header" ref="headerRef">
    <audio :src="voiceUrl" autoplay controls loop preload ref="audio" v-if="isPlay" hidden="true">
      您的浏览器不支持audio标签
    </audio>
    <div class="logo-box">
      <div
        class="logo-text"
        @click="pushToHomePage"
        :style="{ backgroundImage: `url(${headerLogo})` }"
      ></div>
      <div class="toggle-icon" v-if="showAsideMenu" @click="changeCollapse">
        <em :class="menuCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></em>
      </div>
    </div>
    <div class="header-info">
      <ul>
        <li v-if="hasAuth(authCodes.GUIDE)">
          <el-dropdown @command="perationGuideHandle">
            <span class="el-dropdown-link">
              {{ $t('操作指引') }}
              <i class="el-icon-video-play"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in fireMenu" :key="item.code" :command="item.code">
                {{ item.label }}
                <i class="el-icon-video-play"></i>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li v-if="hasAuth(authCodes.LANGUAGE)">
          <el-dropdown trigger="click" placement="bottom">
            <el-tooltip effect="dark" :content="$t('语言')">
              <span class="el-dropdown-link">
                <em class="icon iconfont icon-language"></em>
              </span>
            </el-tooltip>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="e in langs" :key="e" @click.native="setLang(e)">
                {{ locales[e] }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li v-if="hasAuth(authCodes.LANGUAGE)">
          <el-tooltip effect="dark" :content="theme === 'dark' ? $t('黑夜主题') : $t('白天主题')">
            <em class="icon iconfont" :class="`icon-${theme}`" @click="changeTheme"></em>
          </el-tooltip>
        </li>
        <li v-if="hasAuth(authCodes.ALARM_SILENT)">
          <el-tooltip effect="dark" :content="$t('关闭当前报警')">
            <em class="icon iconfont icon-alarm-silent" @click="stopAlarm()"></em>
          </el-tooltip>
        </li>
        <li v-if="hasAuth(authCodes.VOICE)">
          <el-tooltip effect="dark" :content="$t(alarmVoice ? '关闭声音' : '打开声音')">
            <em
              class="icon iconfont"
              :class="alarmVoice ? 'icon-shengyindakai' : 'icon-shengyinguanbi'"
              @click="alarmVoiceHandler()"
            ></em>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip effect="dark" :content="$t(fullScreen ? '退出全屏' : '进入全屏')">
            <em
              class="icon iconfont"
              :class="fullScreen ? 'icon-quitquanping' : 'icon-quanping'"
              @click="screenToggle"
            ></em>
          </el-tooltip>
        </li>
        <li v-if="hasAuth(authCodes.DEVICE_MONITOR)">
          <el-tooltip effect="dark" :content="$t('打开设备监控')">
            <em
              class="icon iconfont icon-shexiangtou open-device-monitor"
              :class="alarmFlag | stateClass"
              @click="drawerVisible = !drawerVisible"
            ></em>
          </el-tooltip>
        </li>
        <li>{{ nowTime }}</li>
        <li>
          <el-dropdown trigger="click" placement="bottom">
            <span class="el-dropdown-link">
              {{ userInfo.name }}
              <em class="el-icon-arrow-down el-icon--right"></em>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(v, i) in filteredAdminMenu"
                :key="i"
                @click.native="v.click"
              >
                {{ translateTo(v.label) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li v-if="hasAuth(authCodes.BACK) && !isLocal">
          <button class="button-style" @click="back">{{ $t('返回') }}</button>
        </li>
      </ul>
    </div>
    <el-dialog
      :title="$t('修改密码')"
      :visible.sync="psdVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      width="30%"
    >
      <el-form :model="psdModel" ref="form" :rules="rules" status-icon>
        <el-form-item :label="$t('旧密码')" prop="oldPsd">
          <el-input
            :type="type"
            v-model="psdModel.oldPsd"
            autocomplete="new-password"
            @focus="type = 'password'"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('新密码')" prop="newPsd">
          <el-input
            type="password"
            v-model="psdModel.newPsd"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('确认密码')" prop="checkNewPsd">
          <el-input
            type="password"
            v-model="psdModel.checkNewPsd"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="psdVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="primary" @click="modifyPassword" v-loading="sureLoading">
          {{ $t('确认') }}
        </el-button>
      </span>
    </el-dialog>
    <profile-popup :visible.sync="pfVisible"></profile-popup>
    <device-drawer :visible.sync="drawerVisible"></device-drawer>
  </div>
</template>

<script>
import { dictByCodeServer } from '@/api/dict';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import screenfull from 'screenfull';
import ProfilePopup from './profilePopup';

import { modifyPsd } from '@/api/auth';
import { formatTimestamp, backToLogin, setSessionItem, awaitTo } from '@/utils/utils';
import Type from '@/store/mutation-type';
import ctt from '@/utils/const';
import { isEmpty } from '@/utils/is';
import { useDialog } from '@/components/dialog';

// 常量提取 - 避免在组件实例中重复创建
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,}$/;

// 权限码常量
const AUTH_CODES = {
  GUIDE: '010219', // 操作指引
  LANGUAGE: '010108', // 语言设置
  ALARM_SILENT: '010111', // 关闭当前报警
  VOICE: '010101', // 声音控制
  DEVICE_MONITOR: '010109', // 设备监控
  BACK: '010102', // 返回按钮
  CHANGE_PASSWORD: '010106', // 修改密码
  PROFILE: '010107', // 个人设置
  ONLINE_SERVICE: '010104', // 在线服务
  CLIENT_DOWNLOAD: '010110', // 客户端下载
  LOGOUT: '010105' // 退出登录
};

const LOCALES = {
  en: 'English',
  'zh-CN': '中文简体',
  fr: 'Français',
  ar: 'العربية',
  ru: 'Русский',
  es: 'Español'
};

const FIRE_MENU = [
  { label: '实时监测', code: 0 },
  { label: '监测记录', code: 1 },
  { label: '检测记录', code: 2 },
  { label: '报警记录', code: 3 },
  { label: '报警统计', code: 4 },
  { label: '危险物信息', code: 5 }
];

/**
 * 页面头部组件
 * 功能包括：Logo显示、菜单折叠、操作指引、语言切换、主题切换、
 * 报警控制、声音控制、全屏切换、设备监控、时间显示、用户菜单等
 */
export default {
  name: 'homeHeader',
  inject: ['showAsideMenu'],
  components: {
    ProfilePopup,
    DeviceDrawer: () => import('./components/device-drawer')
  },
  data() {
    const validateNewPsd = (_rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.translateTo('请输入密码', 'layout')));
      } else {
        if (PASSWORD_REGEX.test(value)) {
          if (this.psdModel.checkNewPsd !== '') {
            this.$refs.form.validateField('checkNewPsd');
          }
          callback();
        } else {
          callback(new Error(this.translateTo('验证密码模板', 'layout', { num: 8 })));
        }
      }
    };
    const validateCheckNewPsd = (_rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.translateTo('请再次输入密码', 'layout')));
      } else if (value !== this.psdModel.newPsd) {
        callback(new Error(this.translateTo('两次输入密码不一致!', 'layout')));
      } else {
        callback();
      }
    };
    return {
      locales: LOCALES,
      authCodes: AUTH_CODES, // 权限码常量，供模板使用
      nowTime: formatTimestamp(new Date().getTime()),
      fullScreen: false,
      psdVisible: false,
      pfVisible: false,
      sureLoading: false,
      drawerVisible: false,
      type: 'text',
      guideVideoList: [], // 修复：声明响应式属性，避免 Vue 2 无法追踪变化
      videoUrl: '', // 修复：声明响应式属性
      psdModel: {
        oldPsd: '',
        newPsd: '',
        checkNewPsd: ''
      },
      rules: {
        oldPsd: [
          {
            required: true,
            validator: (_rule, value, callback) => {
              if (isEmpty(value)) {
                callback(new Error(this.translateTo('请输入旧密码', 'layout')));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        newPsd: [{ required: true, validator: validateNewPsd, trigger: 'blur' }],
        checkNewPsd: [{ required: true, validator: validateCheckNewPsd, trigger: 'blur' }]
      },
      fireMenu: FIRE_MENU,
      adminMenu: [
        {
          label: '修改密码',
          code: AUTH_CODES.CHANGE_PASSWORD,
          click: () => {
            this.psdVisible = true;
          }
        },
        {
          label: '个人设置',
          code: AUTH_CODES.PROFILE,
          click: () => {
            this.pfVisible = true;
          }
        },
        {
          label: '在线服务',
          code: AUTH_CODES.ONLINE_SERVICE,
          click: () => {
            this.$alert('<image src="static/image/nova-public.jpg"/>', '在线服务', {
              callback() {},
              dangerouslyUseHTMLString: true,
              center: true,
              showConfirmButton: false,
              closeOnClickModal: true,
              closeOnPressEscape: true
            });
          }
        },
        {
          label: '客户端下载',
          code: AUTH_CODES.CLIENT_DOWNLOAD,
          click: () => {
            this.$router.push('/download');
          }
        },
        {
          label: '退出',
          code: AUTH_CODES.LOGOUT,
          localHidden: true,
          click: () => {
            this.$msgbox({
              title: this.translateTo('提示'),
              message: this.translateTo('确定要退出吗'),
              showCancelButton: true,
              confirmButtonText: this.translateTo('confirm'),
              cancelButtonText: this.translateTo('cancel'),
              beforeClose: async (action, instance, done) => {
                if (action === 'confirm') {
                  instance.confirmButtonLoading = true;
                  instance.confirmButtonText = this.translateTo('exiting');
                  const [error] = await awaitTo(this.logout());
                  if (error) console.error('[ERROR][LOGOUT]--', error);
                  instance.confirmButtonLoading = false;
                  done();
                } else {
                  done();
                }
              }
            })
              .then(() => {
                screenfull.exit();
                backToLogin();
              })
              .catch(() => {
                return false;
              });
          }
        }
      ]
    };
  },
  computed: {
    // 用户信息和有效数据
    ...mapState('admin', ['userInfo', 'validData']),
    // 应用状态：菜单折叠、报警声音、本地模式、语言、主题等
    ...mapState('app', ['menuCollapse', 'alarmVoice', 'isLocal', 'lang', 'langs', 'theme']),
    // 报警标志
    ...mapGetters('socket', ['alarmFlag']),
    // 报警声音URL
    voiceUrl() {
      if (this.alarmFlag === 1) {
        return require('@/assets/voice/warn.wav');
      } else if (this.alarmFlag === 2) {
        return require('@/assets/voice/danger.wav');
      }
      return '';
    },
    isPlay() {
      return this.alarmVoice && this.alarmFlag;
    },
    headerLogo() {
      const { companyLogo } = this.$store.state.admin.profile || {};
      const img = companyLogo || require('@/assets/image/local-logo.png');
      if (this.validData) return img;
      return '';
    },
    // 过滤后的管理菜单，避免在模板中混用 v-if 和 v-for
    filteredAdminMenu() {
      return this.adminMenu.filter(v => {
        return this.isLocal
          ? this.hasAuth(v.code) && !v.localHidden
          : this.hasAuth(v.code) || v.show;
      });
    }
  },
  methods: {
    // 权限检查辅助方法
    hasAuth(code) {
      return !!this.authMenu[code];
    },
    // Vuex mutations
    ...mapMutations('app', {
      changeCollapse: Type.CHANGE_COLLAPSE,
      alarmVoiceHandler: Type.ALARM_VOICE,
      setTheme: 'setTheme'
    }),
    ...mapMutations('socket', {
      closeWbsocket: Type.CLOSE_WEBSOCKET
    }),
    // Vuex actions
    ...mapActions('app', ['silentAlarmDevice', 'setLang']),
    ...mapActions('admin', ['logout']),
    // 切换主题（深色/浅色）
    changeTheme() {
      const t = this.theme === 'dark' ? 'light' : 'dark';
      this.setTheme(t);
    },
    // 停止当前报警
    stopAlarm() {
      this.silentAlarmDevice();
    },
    // 更新时间并计算到下一秒的精确延迟
    curDate() {
      const now = new Date();
      this.nowTime = formatTimestamp(now.getTime());
      // 计算到下一秒的毫秒数，确保在秒数变化时精确更新
      const delay = 1000 - now.getMilliseconds();
      this.timer = setTimeout(this.curDate, delay);
    },
    // 返回上一页
    back() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    // 切换全屏状态
    screenToggle() {
      if (screenfull.isEnabled) {
        screenfull.toggle();
      }
    },
    // 修改密码
    modifyPassword() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.sureLoading = true;
        modifyPsd({
          oldPassword: this.psdModel.oldPsd,
          newPassword: this.psdModel.newPsd
        })
          .then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: res.message
              });
              setSessionItem(ctt.ADMIN_TOKEN, res.data);
            }
          })
          .finally(() => {
            this.$refs.form.resetFields();
            this.sureLoading = false;
            this.psdVisible = false;
          });
      });
    },
    // 关闭密码对话框前的处理
    beforeClose() {
      this.$refs.form.resetFields();
      this.psdVisible = false;
    },
    // 加载操作指引视频列表
    async loadGuideVideoHandle() {
      try {
        const videoRes = await dictByCodeServer('firefighting');
        this.guideVideoList = videoRes.data.sort((a, b) => a.sort - b.sort);
      } catch (error) {
        console.error('[ERROR][loadGuideVideoHandle]', error);
      }
    },
    // 处理操作指引点击事件
    perationGuideHandle(menuCode) {
      const prefix = 'https://htnova-data.oss-cn-beijing.aliyuncs.com';
      this.videoUrl = prefix + this.guideVideoList[menuCode].value;

      useDialog({
        title: this.fireMenu[menuCode].label,
        width: '1000px',
        marginTop: '20px',
        appendToBody: false,
        container: this.$refs.headerRef,
        style: 'border: 1px solid rgba(12, 106, 182, 0.8);',
        modal: false,
        slots: {
          default: () => (
            <div style="width: 100%; height: 500px;">
              <video controls style="width: 100%; height: 100%;">
                <source src={this.videoUrl} type="video/mp4" />
              </video>
            </div>
          )
        }
      });
    }
  },
  watch: {
    // 监听报警播放状态，处理自动播放问题
    isPlay(newVal) {
      if (newVal) {
        // 解决页面初始化自动播放失效问题
        this.$nextTick(() => {
          if (this.$refs['audio'] && this.$refs['audio'].paused) {
            this.alarmVoiceHandler();
            this.alarmVoiceHandler();
          }
        });
      }
    }
  },
  created() {
    // 加载操作指引视频
    this.loadGuideVideoHandle();
    // 启动精确时间更新
    this.curDate();
    // 保存全屏状态变化监听器引用，便于销毁时移除
    this._screenfullHandler = () => {
      this.fullScreen = !this.fullScreen;
    };
    screenfull.onchange(this._screenfullHandler);
  },
  beforeDestroy() {
    // 清理定时器
    clearTimeout(this.timer);
    // 移除全屏状态监听器，防止内存泄漏
    if (this._screenfullHandler) {
      screenfull.off('change', this._screenfullHandler);
    }
  }
};
</script>

<style lang="scss">
.home-header {
  background-color: var(--header-bg);
  color: var(--header-text);
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  .logo-box {
    display: flex;
    .logo-text {
      width: 180px;
      height: inherit;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      cursor: pointer;
      filter: var(--header-logo-filter);
    }
    .toggle-icon {
      width: 60px;
      text-align: center;
      font-size: 26px;
      color: var(--header-toggle-icon-color);
      cursor: pointer;
    }
  }
  .header-info {
    align-items: flex-end;
    > ul {
      display: flex;
      font-size: 14px;
      color: var(--header-text);
      justify-content: space-between;
      > li {
        min-width: 30px;
        text-align: center;
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        .el-dropdown-link {
          cursor: pointer;
          color: var(--header-link-color);
        }
      }
    }
  }
  .open-device-monitor {
    @include state-textstyle;
  }
}
.model-map {
  width: 100%;
  height: 80vh;
}
</style>
